<template>
  <section class="listing">
    <Log
      v-if="log"
      :log="log"
      :close="closeLog"
    />
    <div class="header">
      <div class="title">Logs</div>
    </div>
    <form @submit.prevent="getData" class="form form-search">
      <div class="form-inputs">
        <div class="form-inputs-line">
          <input v-model="iniDate" type="date" style="flex-grow: 1" />
          <input v-model="iniHour" v-mask="'##:##:##'" type="text" style="width: 90px" />
          <input v-model="endDate" type="date" style="flex-grow: 1" />
          <input v-model="endHour" v-mask="'##:##:##'" type="text" style="width: 90px" />
        </div>
        <div class="form-inputs-line">
          <select v-model="level">
            <option :value="null">Tipo</option>
            <option value="info">Info</option>
            <option value="warn">Warning</option>
            <option value="error">Error</option>
          </select>
          <select v-model="from">
            <option :value="null">Módulo</option>
            <option value="backend">Backend</option>
            <option value="web">Web</option>
            <!-- <option value="app">App</option> -->
            <option value="service">Serviço</option>
          </select>
        </div>
      </div>
      <div>
        <button type="submit" class="btn-search">
          <i class="fas fa-search"></i>
        </button>
      </div>
    </form>
    <transition name="show" mode="out-in">
      <i v-if="loading" class="fas fa-spinner loading-big"></i>
      <div v-if="!loading" style="margin-top: 10px">
        <table class="table-logs">
          <tr v-for="line in data" @click="openLog(line)" :key="line.id" :class="line.level">
            <td width="15" class="level">
              <i v-if="line.level === 'info'" class="fas fa-info"></i>
              <i v-else-if="line.level === 'warn'" class="fas fa-exclamation"></i>
              <i v-else class="fas fa-times"></i>
            </td>
            <td width="110">{{ `${getDay(line.dateFmt)}/${getMonth(line.dateFmt)} ${getTime(line.dateFmt)}` }}</td>
            <td width="70">{{ line.from }}</td>
            <td class="ellipsis"><span>{{ line.message }}</span></td>
          </tr>
        </table>
      </div>
    </transition>
  </section>
</template>

<script>
import logger from '../../logger'
import { get } from '../api/log'
import Log from './Log.vue'

export default {
  components: { Log },
  data () {
    return {
      loading: true,
      iniDate: null,
      iniHour: '00:00:00',
      endDate: null,
      endHour: '23:59:59',
      data: [],
      level: 'error',
      from: null,
      log: null
    }
  },
  async mounted () {
    try {
      const date = new Date()
      this.endDate = date.toISOString().split('T')[0]
      // date.setDate(date.getDate() - 1)
      this.iniDate = date.toISOString().split('T')[0]
      this.getData()
    } catch (error) {
      logger.error(error)
    }
  },
  methods: {
    openLog (log) {
      this.log = log
    },
    closeLog () {
      this.log = null
    },
    async getData () {
      this.loading = true
      try {
        const data = await get(
          `${this.iniDate} ${this.iniHour}`,
          `${this.endDate} ${this.endHour}`,
          this.from,
          this.level
        )
        this.data = data
      } catch (error) {
        logger.error(error)
      }
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.form-search {
  flex-direction: row;
  align-items: center;
  padding: 0;
  padding-bottom: 10px;

  .form-inputs {
    width: calc(100% - 45px);
  }

  .form-inputs-line {
    display: flex;
    flex-wrap: wrap;
  }

  input, select {
    flex-grow: 1;
    margin: 5px;
  }
}

.btn-search {
  flex-shrink: 0;
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  width: 39px;
  height: 39px;
  color: #fff;
  border-radius: 50%;
  border: 1px solid $primary-color;
  cursor: pointer;
  font-size: 1.1em;
  margin-left: 5px;
  &:focus {
    outline: 0;
  }
}

.table-logs {
  width: 100%;
  font-size: 0.9em;
  color: #333;
  border-spacing: 0;
  .level {
    text-align: center;
  }
  tr {
    cursor: pointer;
    &:hover { background-color: $light-color !important; }
    &.info { background-color: #9f9ffc; .level { color: #1e1e1f } }
    &.warn { background-color: #f0f0ad; .level { color: #1e1e1f } }
    &.error { background-color: #fb7575; .level { color: #1e1e1f } }
  }
  td {
    padding: 8px 5px;
    border-bottom: 1px solid #fff;
  }
  .ellipsis {
    position: relative;
    &:before {
      content: '&nbsp;';
      visibility: hidden;
    }
    span {
      position: absolute;
      left: 0;
      right: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

// Desktop
@media screen and (min-width: $desktop-width) {
  .form-inputs-line {
    flex-wrap: nowrap !important;
  }
}
</style>
